import classNames from 'classnames';

const FA = props => (
  <i className={classNames("fas", props.style && "fa-"+props.style, "fa-"+props.icon, props.className)} />
);

const FW = props => <FA style="fw" {...props} />;

const FASpin = props => <FA style="spin" {...props} />;

export {FA, FW, FASpin};
